import { useEffect, useState } from 'react';
import { PlayerContent } from '@/types/ContentPayload';

export function usePreloadedImages(content?: PlayerContent) {
  const [preloadedImages, setPreloadedImages] = useState(
    new Map<string, HTMLImageElement>(),
  );

  useEffect(() => {
    if (!content) return;

    const imageUrls = new Set(
      content.content
        ?.flatMap((item) => item.slides)
        .filter((slide) => slide.contentType?.startsWith('image/'))
        .map((slide) => slide.url) ?? [],
    );

    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
      setPreloadedImages((prev) => new Map(prev).set(url, img));
    });
  }, [content]);

  return preloadedImages;
}
